import { render, staticRenderFns } from "./WorkersBase.vue?vue&type=template&id=265dc269&"
import script from "./WorkersBase.vue?vue&type=script&lang=js&"
export * from "./WorkersBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports